module.exports = __webpack_public_path__ + "fa4cf8a60fecc6d69054b33ad531b944.jpg";